/* Amanda's Gifts: live-theme product-page extras on Horizon.
   1) "You Save X%" pill next to the product price (live Dawn price snippet), kept in sync on variant change.
   2) Zero-height blocks in the product details (empty app blocks) don't leave a gap. */
(() => {
  const money = (el) => {
    if (!el) return NaN;
    const t = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.');
    return parseFloat(t);
  };
  function updatePill(pp) {
    const c = pp.querySelector('[ref="priceContainer"]');
    if (!c) return;
    const price = money(c.querySelector('.price bdi, .price'));
    const compare = money(c.querySelector('.compare-at-price bdi, .compare-at-price'));
    let pill = pp.querySelector('.ag-save-pill');
    if (!(compare > price && price > 0)) { if (pill) pill.hidden = true; return; }
    if (!pill) { pill = document.createElement('span'); pill.className = 'ag-save-pill'; c.appendChild(pill); }
    const text = 'You Save ' + Math.round(((compare - price) * 100) / compare) + '%';
    if (pill.textContent !== text) pill.textContent = text;
    pill.hidden = false;
  }
  function initPrices() {
    document.querySelectorAll('.product-details product-price').forEach((pp) => {
      updatePill(pp);
      if (pp.dataset.agObserved) return;
      pp.dataset.agObserved = '1';
      new MutationObserver(() => updatePill(pp)).observe(pp, { childList: true, subtree: true, characterData: true });
    });
  }
  function initGaps() {
    if (!('ResizeObserver' in window)) return;
    const vp = document.querySelector('.product-details variant-picker');
    const list = vp && vp.parentElement;
    if (!list || list.dataset.agGaps) return;
    list.dataset.agGaps = '1';
    const ro = new ResizeObserver((entries) => {
      const g = getComputedStyle(list).rowGap;
      for (const e of entries) {
        const zero = e.target.offsetHeight === 0;
        e.target.classList.toggle('ag-zero', zero);
        e.target.style.marginBlockEnd = zero && g && g !== 'normal' ? '-' + g : '';
      }
    });
    [...list.children].forEach((el) => ro.observe(el));
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && ro.observe(n)))).observe(list, { childList: true });
  }
  const init = () => { initPrices(); initGaps(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
